function closeTryOn () {
  const preview = document.getElementById("geenee-preview-container")
  if(preview) {
    preview.remove()
  }
}

  window.addEventListener(
    "message",
    (event) => {
      if (event.data.action !== "buy-button-clicked") {
        return;
      }
      let formData = {
        'items': [{
          'id': event.data.id,
          'quantity': 1
        }]
      };
      
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(response => response.json())
      .then(data => {
          return fetch(window.Shopify.routes.root + 'cart.js');
        })
      .then(cartData => { 
        const cartDrawer = document.querySelector('m-cart-drawer');
        if (cartDrawer) {
          cartDrawer.onCartDrawerUpdate();
          cartDrawer.updateCartCount(cartData.item_count);
          cartDrawer.open();
        }
      })
      .catch((error) => {
        console.error('Error:', error);
      });
    }
  );

document.addEventListener('click', function(event) {
  var isClickInside = document.getElementById('preview')?.contains(event.target);

  if (!isClickInside) {
    closeTryOn();
  }
});



function tryOnClick (event, id, variant) {
  console.log('try-on:', id, variant);
    event.preventDefault();
    event.stopPropagation();
      const geeneeWrapper = document.createElement('div')
      geeneeWrapper.id = "geenee-preview-container"
      document.body.appendChild(geeneeWrapper)
      
      geeneeWrapper.innerHTML = `
        <div class="geenee-sticky-container">
            <span class="geenee-window-close" onclick="closeTryOn()">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0002 12.7071L19.0001 19.7071L19.7072 19L12.7073 12L19.7073 4.99995L19.0002 4.29285L12.0002 11.2929L5.00008 4.29285L4.29297 4.99995L11.293 12L4.29312 19L5.00023 19.7071L12.0002 12.7071Z" fill="white"/>
</svg>
              </span>
            <iframe class="geenee-window" id="preview" allow="camera;microphone;web-share" src="https://projects.geenee.ar/lucyd/?id=${id}&variant=${variant}"></iframe>
        </div>
      `
  }